import {Route, Routes, Outlet, Navigate} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../../_metronic/layout/core'
import {ListWrapper} from './authors-list/List'

const authorsBreadcrumbs: Array<PageLink> = [
  {
    title: 'Gerenciamento de Responsáveis',
    path: '/apps/guardians-management/guardians',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const Page = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='guardians'
          element={
            <>
              <PageTitle breadcrumbs={authorsBreadcrumbs}>Lista de Responsáveis</PageTitle>
              <ListWrapper />
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to='/apps/guardians-management/guardians' />} />
    </Routes>
  )
}

export default Page
